"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("./ConditionalHelper");
var replacePlaceholders_1 = require("../utils/replacePlaceholders");
var isArrayLike_1 = require("../utils/isArrayLike");
var utils_1 = require("../utils");
var typeChecks_1 = require("../utils/typeChecks");
var collection_1 = require("../utils/collection");
var transform_1 = require("../query/transform");
var RedirectHelper = /** @class */ (function () {
    function RedirectHelper(url, base, options) {
        this.redirectContext = {};
        this.originPathPlaceholder = false;
        this.originPath = '';
        this.shouldCompareUserURL = false;
        if (!base) {
            base = window && window.location.origin;
        }
        this.url = new URL(url, base);
        if (options) {
            if (options.shouldCompareUserURL) {
                this.shouldCompareUserURL = options.shouldCompareUserURL;
            }
            if (options.translationHelper) {
                this.translationHelper = options.translationHelper;
            }
        }
    }
    /**
     * Should be deprecated in future, application and/or component should rather get the url based on redirect logic via getRedirectPath
     * then call the redirect method with the url and the options.
     * This is for the apps needing the redirect url to log to the data layer
     * @param redirect
     * @param inputs
     */
    RedirectHelper.prototype.go = function (redirect, inputs) {
        var options = redirect.options;
        var redirectPath = this.getRedirectPath(redirect, inputs);
        this.redirect(redirectPath, options);
    };
    RedirectHelper.prototype.redirect = function (url, options) {
        var currentUserUrl = document.location.href;
        if (url && (!this.shouldCompareUserURL || currentUserUrl !== url)) {
            if (options && options.target) {
                window.open(url, options.target);
            }
            else if (url === currentUserUrl) {
                window.location.reload();
            }
            else {
                document.location.href = url;
            }
        }
    };
    RedirectHelper.prototype.getRedirectPath = function (redirect, inputs) {
        if (redirect) {
            var conditionalRedirects = redirect.conditionalRedirects, defaultUrl = redirect.defaultUrl, base = redirect.base, _a = redirect.options, options = _a === void 0 ? {} : _a;
            var validRedirect = void 0;
            if (conditionalRedirects) {
                validRedirect = conditionalRedirects.find(function (conditionalRedirect) {
                    var conditional = conditionalRedirect.conditional;
                    var conditionalHelper = new ConditionalHelper_1.ConditionalHelper(conditional);
                    return conditionalHelper.matches(inputs);
                });
            }
            this.originPath = this.url.pathname;
            if (options.originPathTransforms) {
                for (var _i = 0, _b = options.originPathTransforms; _i < _b.length; _i++) {
                    var transformOptions = _b[_i];
                    var transform = new transform_1.Transform(transformOptions, this.translationHelper);
                    this.originPath = transform.execute(this.originPath, { queryOptionsType: 'none' }, {});
                }
            }
            var url = (validRedirect && validRedirect.url) || defaultUrl;
            var redirectOptions = (validRedirect && validRedirect.options) || options;
            this.initializeContext(redirectOptions, inputs);
            var replacedUrl = this.replacePlaceholders(url);
            return this.getRedirectUrl(replacedUrl, base, null, null, false);
        }
    };
    RedirectHelper.prototype.getRedirectUrl = function (redirectString, redirectBase, options, inputs, initializeContext) {
        if (initializeContext === void 0) { initializeContext = true; }
        if (initializeContext) {
            this.initializeContext(options, inputs);
        }
        var base = this.redirectOptions.preserveOrigin ? this.url.origin : redirectBase;
        var redirectUrl = new URL(redirectString, base || window && window.location.origin);
        this.updatePathname(redirectUrl);
        this.updateSearchQueryString(redirectUrl);
        this.updateHash(redirectUrl);
        return redirectUrl.toString();
    };
    RedirectHelper.prototype.initializeContext = function (redirectOptions, inputs) {
        if (redirectOptions === void 0) { redirectOptions = {}; }
        if (inputs === void 0) { inputs = {}; }
        this.redirectContext.options = redirectOptions;
        this.inputs = inputs;
    };
    Object.defineProperty(RedirectHelper.prototype, "redirectOptions", {
        get: function () {
            return this.redirectContext.options || {};
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHelper.prototype, "translatePlaceholderValues", {
        get: function () {
            return this.translationHelper && this.redirectContext.options && this.redirectContext.options.translatePlaceholderValues;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHelper.prototype, "inputs", {
        get: function () {
            if (this.translatePlaceholderValues && this.hasTranslatedInputs) {
                return this.redirectContext.inputsTranslated;
            }
            return this.redirectContext.inputs || {};
        },
        set: function (inputs) {
            var _this = this;
            this.redirectContext.inputs = inputs || {};
            var inputsTranslated = __assign({}, inputs);
            if (this.translatePlaceholderValues) {
                Object.keys(inputsTranslated).forEach(function (inputKey) {
                    inputsTranslated[inputKey] = _this.translationHelper.translate(inputsTranslated[inputKey]);
                });
                this.redirectContext.inputsTranslated = inputsTranslated;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHelper.prototype, "hasInputs", {
        get: function () {
            return this.redirectContext.inputs && Object.keys(this.redirectContext.inputs).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RedirectHelper.prototype, "hasTranslatedInputs", {
        get: function () {
            return this.redirectContext.inputsTranslated && Object.keys(this.redirectContext.inputsTranslated).length > 0;
        },
        enumerable: true,
        configurable: true
    });
    RedirectHelper.prototype.updatePathname = function (redirectUrl) {
        var redirectPathSegments = [];
        var paramCaseOptions = Object.assign({ apply: false, separator: '-' }, this.redirectOptions.paramCase);
        var shouldAddTrailingSlash = this.redirectOptions.forceTrailingSlash || false;
        var currentUrlSegments = this.originPath.split('/');
        var redirectUrlSegements = redirectUrl.pathname.split('/');
        if (this.redirectOptions.preserveOriginPathWithOverrides) {
            // We need to ensure that we are counting the segments and not the slashes
            var currentPath = this.originPath.replace(/^\/|\/$/g, '').split('/');
            var redirectUrlPath = redirectUrl.pathname.replace(/^\/|\/$/g, '').split('/');
            var ignore_1 = this.redirectOptions.ignoreSegmentOverridePlaceholder || '';
            var newSegments = void 0;
            // If the current Path is shorter than the config then the config segments can be added to the end and ignoring segments that where marked
            if (currentPath.length <= redirectUrlPath.length) {
                // Check if the config is the same length or longer as the current url then add the trailing slash in config if present
                shouldAddTrailingSlash = redirectUrlSegements[redirectUrlSegements.length - 1] === '';
                newSegments = redirectUrlSegements.map(function (newSegment, idx) {
                    var oldSegment = currentUrlSegments[idx];
                    if (!typeChecks_1.isNullOrEmpty(newSegment) && newSegment !== ignore_1) {
                        return newSegment;
                    }
                    return oldSegment;
                }).filter(function (segment) { return !typeChecks_1.isNullOrEmpty(segment); });
            }
            else {
                // If current url is longer add trailing slash if present in current url
                shouldAddTrailingSlash = currentUrlSegments[currentUrlSegments.length - 1] === '';
                newSegments = currentUrlSegments.map(function (oldSegment, idx) {
                    var newSegment = redirectUrlSegements[idx];
                    if (!typeChecks_1.isNullOrEmpty(newSegment) && newSegment !== ignore_1) {
                        return newSegment;
                    }
                    return oldSegment;
                }).filter(function (segment) { return !typeChecks_1.isNullOrEmpty(segment); });
            }
            redirectPathSegments.push.apply(redirectPathSegments, newSegments);
        }
        else {
            // prepend path with origin path
            if (this.redirectOptions.preserveOriginPath && !this.originPathPlaceholder) {
                redirectPathSegments.push.apply(redirectPathSegments, currentUrlSegments);
            }
        }
        // append dynamic pathname
        if (isArrayLike_1.isArrayLike(this.redirectOptions.urlParams) && this.redirectOptions.urlParams.length > 0) {
            var dynamicPathSegments = this.replacePlaceholdersOnCollection(this.redirectOptions.urlParams);
            redirectPathSegments.push.apply(redirectPathSegments, this.applyParamCaseToCollection(dynamicPathSegments, paramCaseOptions));
        }
        else if (!this.redirectOptions.preserveOriginPathWithOverrides) {
            // apply pathname derived from static redirect pathname
            redirectPathSegments.push.apply(redirectPathSegments, redirectUrlSegements);
        }
        // finally append dynamic endpoint
        if (this.redirectOptions.urlEndpoint && isArrayLike_1.isArrayLike(this.redirectOptions.urlEndpoint) && this.redirectOptions.urlEndpoint.length > 0) {
            var endpointSegments = this.replacePlaceholdersOnCollection(this.redirectOptions.urlEndpoint);
            var endpoint = this.applyParamCaseToCollection(endpointSegments, paramCaseOptions).join(paramCaseOptions.separator);
            redirectPathSegments.push(endpoint);
        }
        // merge pathname segments to save final pathname
        var reducedPathSegments = redirectPathSegments.reduce(function (segments, segment, segmentIndex) {
            if (segment !== '') {
                segments.push(segment);
            }
            return segments;
        }, []);
        if (shouldAddTrailingSlash && reducedPathSegments[reducedPathSegments.length - 1] !== '') {
            reducedPathSegments.push('');
        }
        // save
        redirectUrl.pathname = reducedPathSegments.join('/');
    };
    RedirectHelper.prototype.updateSearchQueryString = function (redirectUrl) {
        var _this = this;
        var redirectSearchParamsSegments = this.getSearchParamsSegments(redirectUrl);
        // override origin with static redirect search params
        if (this.redirectOptions.preserveOriginQueryString) {
            var originSearchParams = this.getSearchParamsSegments(this.url);
            redirectSearchParamsSegments = Object.assign({}, originSearchParams, redirectSearchParamsSegments);
        }
        // override static redirect with dynamic search params
        if (isArrayLike_1.isArrayLike(this.redirectOptions.queryStringParams) && this.redirectOptions.queryStringParams.length > 0) {
            var dynamicSearchParams = this.redirectOptions.queryStringParams.reduce(function (params, param) {
                var replacedValue = _this.replacePlaceholders(param.value);
                if (!param.optional || (param.optional && !typeChecks_1.isNullOrEmpty(replacedValue))) {
                    params[param.key] = replacedValue;
                }
                return params;
            }, {});
            redirectSearchParamsSegments = Object.assign({}, redirectSearchParamsSegments, dynamicSearchParams);
        }
        // save search params segments
        var searchParamString = this.getSearchParamsString(redirectSearchParamsSegments);
        if (searchParamString) {
            redirectUrl.search = searchParamString;
        }
    };
    RedirectHelper.prototype.updateHash = function (redirectUrl) {
        if (!redirectUrl.hash && this.redirectOptions.preserveOriginHash) {
            redirectUrl.hash = this.url.hash;
        }
    };
    RedirectHelper.prototype.applyParamCaseToCollection = function (collection, options) {
        if (options.apply) {
            return collection.map(function (value) { return utils_1.changeCase.paramCase(value, { delimiter: options.separator }); });
        }
        return collection;
    };
    RedirectHelper.prototype.replacePlaceholdersOnCollection = function (collection) {
        var _this = this;
        var updatedCollection = collection;
        if (this.hasInputs) {
            updatedCollection = updatedCollection.map(function (value) { return _this.replacePlaceholders(value); });
        }
        return collection_1.filterOutEmpty(updatedCollection);
    };
    RedirectHelper.prototype.replacePlaceholders = function (subject) {
        this.originPathPlaceholder = subject.includes('{originPath}');
        this.inputs['originPath'] = this.originPath;
        return replacePlaceholders_1.replacePlaceholders({ values: this.inputs, text: subject });
    };
    RedirectHelper.prototype.getSearchParamsString = function (searchParams) {
        var _this = this;
        var paramKeys = Object.keys(searchParams);
        if (paramKeys.length > 0) {
            var params = paramKeys.map(function (key) {
                var value = searchParams[key];
                var param = (_this.redirectOptions.queryStringParams || []).find(function (param) { return param.key === key; });
                var encode = (param || {}).encode;
                if ((_this.redirectOptions.encodeQueryStringParams || encode) && encode !== false) {
                    value = encodeURIComponent(value);
                }
                return !typeChecks_1.isNullOrEmpty(searchParams[key]) ? key + "=" + value : key;
            });
            return "?" + params.join('&');
        }
        return;
    };
    RedirectHelper.prototype.getSearchParamsSegments = function (url) {
        var params = {};
        if (url && url.search) {
            var questionMarkStripped = url.search.replace('?', '');
            if (questionMarkStripped) {
                var paramSegments = questionMarkStripped.split('&');
                if (paramSegments) {
                    params = paramSegments.reduce(function (params, param) {
                        var paramParts = param.split('=');
                        if (paramParts[0]) {
                            params[paramParts[0]] = paramParts[1] && decodeURI(paramParts[1]) || undefined;
                        }
                        return params;
                    }, {});
                }
            }
        }
        return params;
    };
    return RedirectHelper;
}());
exports.RedirectHelper = RedirectHelper;
//# sourceMappingURL=RedirectHelper.js.map